let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("j8hoS")).then(() => parcelRequire('5A2f8'));